import { useState, useRef } from 'react';
import clsx from 'clsx';

import '../../../../../administration/pages/ProductEditor/component/courseTeams.scss';
import { useOnClickOutside } from '@/hooks/useOnClickOutside';
import { Button } from '@/components/Button/Button';
import { ButtonList } from '@/components/Button/ButtonList';
import { RLearningJourneySessionDiscussionTeam, RLearningJourneySessionDiscussionTeamMember } from '@/store/v2';

type ViewTeamsMemberRowProps = {
  teams: RLearningJourneySessionDiscussionTeam[];
  member: RLearningJourneySessionDiscussionTeamMember;
  teamIndex: number;
  onTeamSwitch: ({ newTeamId, oldTeamId, memberId }: { newTeamId: number; oldTeamId: number; memberId: number }) => void;
  teamId: number;
};

export const ViewTeamsMemberRow = ({
  teams,
  member,
  teamIndex,
  onTeamSwitch,
  teamId,
}: ViewTeamsMemberRowProps): React.ReactElement => {
  const [showMenu, setShowMenu] = useState(false);

  const node = useRef<HTMLDivElement>(null);

  useOnClickOutside(showMenu, setShowMenu, node);

  return (
    <label className="panel-block" styleName="member-block">
      <div>
        <div styleName="member-name">{member?.user?.username}</div>
        <span styleName="member-email">{member?.user?.email}</span>
      </div>
      <span styleName="member-realm">{member?.user?.realm}</span>
      <ButtonList ref={node} align="right">
        <div className={clsx('dropdown', 'is-right', showMenu && 'is-active')} onClick={() => setShowMenu(!showMenu)}>
          <div className="dropdown-trigger">
            <Button aria-haspopup="true" aria-controls="dropdown-menu" $icon="exchange-alt" />
          </div>
          <div className="dropdown-menu" styleName="team-menu" id="dropdown-menu" role="menu">
            <div className="dropdown-content">
              {teams &&
                [...teams.values()].map(
                  (_team, optionIndex) =>
                    optionIndex !== teamIndex && (
                      <a
                        className="dropdown-item"
                        key={`${teamIndex}-${optionIndex}`}
                        onClick={() => {
                          setShowMenu(!showMenu);
                          onTeamSwitch({ newTeamId: _team?.id, oldTeamId: teamId, memberId: member?.user?.id });
                        }}
                      >
                        <span className="body1">Team {optionIndex + 1}</span>
                      </a>
                    )
                )}
            </div>
          </div>
        </div>
      </ButtonList>
    </label>
  );
};
